export enum LogoutParams {
  /**
   * Query parameter for logout reason
   */
  LogoutReason = 'logoutReason',
}
